import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useRecoilCallback, useRecoilState } from 'recoil'
import CheckItem, { ICON_ALERT } from 'Components/CheckItem/CheckItem'
import DynamicFieldItem, {
  SECTION
} from 'Components/DynamicFiledItem/DynamicFieldItem'
import { mdCheckup } from 'Pages/MessageCheckupSummary/recoil/state/message'
import { notifyParent } from 'Helpers/notifyParent'
import { EmailMessageCheckUpIssueType } from 'Constants/'
import {
  callbackManagerAlert,
  changeAlertCallback
} from 'Pages/MessageCheckupSummary/recoil/callbacks/callbacks'

import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const SummaryDynamicFieldCheck = ({ idMessage, isBee }) => {
  const intl = useIntl()
  const history = useHistory()
  const [
    {
      dynamicFieldsOptionEnabled,
      wrongDynamicTags,
      addToWhiteList,
      silencedAlertsArray
    },
    setMdState
  ] = useRecoilState(mdCheckup)
  const saveManagerAlert = useRecoilCallback(callbackManagerAlert, [])
  const changeAlert = useRecoilCallback(changeAlertCallback, [])

  const handleClick = (e, section) => {
    e.stopPropagation()
    e.preventDefault()
    switch (section) {
      case SECTION.body: {
        if (isBee) {
          history.push(`/messages/email/bee/edit/${idMessage}`)
        } else {
          notifyParent('redirectMainFrame', [
            `form_upd_newsletter.aspx?isNew=true&idNL=${idMessage}`
          ])
        }
        break
      }
      case SECTION.subject || SECTION.preheader:
        history.push(`/messages/email/${idMessage}/overview?source=all&op=mod`)
        break
      default:
        break
    }
  }

  const callbackSaveItems = e => {
    saveManagerAlert(idMessage)
  }

  const wrongDynamicTagsGroup =
    wrongDynamicTags &&
    wrongDynamicTags.reduce((a, item) => {
      a[item.Location] = a[item.Location] || []
      a[item.Location].push(item)
      return a
    }, Object.create(null))

  const dynamicFieldPreheader = wrongDynamicTagsGroup &&
    'Preheader' in wrongDynamicTagsGroup && (
      <>
        <DynamicFieldItem
          section={SECTION.preheader}
          items={wrongDynamicTagsGroup.Preheader}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.DynamicFieldsWarning,
              e.toLowerCase()
            )
          }
          alert={
            !dynamicFieldsOptionEnabled
              ? silencedAlertsArray.length > 0 &&
                silencedAlertsArray.find(
                  e =>
                    e.issueType ===
                    EmailMessageCheckUpIssueType.DynamicFieldsWarning
                ).silenced
              : undefined
          }
          intl={intl}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.SecntionDynamicFields'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.DynamicFieldsSummaryTitleIntl'
            },
            {
              link: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={1}
                  onClick={e => handleClick(e, SECTION.subject)}
                >
                  {e}
                </Link>
              )
            }
          )}
          setModalState={setMdState}
          addToWhiteList={addToWhiteList}
          checkSummary
          icon={!dynamicFieldsOptionEnabled ? 'alert' : undefined}
          callbackSaveItems={() => callbackSaveItems()}
        />
      </>
    )

  const dynamicFieldSubject = wrongDynamicTagsGroup &&
    'Subject' in wrongDynamicTagsGroup && (
      <>
        <DynamicFieldItem
          section={SECTION.subject}
          items={wrongDynamicTagsGroup.Subject}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.DynamicFieldsWarning,
              e.toLowerCase()
            )
          }
          alert={
            !dynamicFieldsOptionEnabled
              ? silencedAlertsArray.length > 0 &&
                silencedAlertsArray.find(
                  e =>
                    e.issueType ===
                    EmailMessageCheckUpIssueType.DynamicFieldsWarning
                ).silenced
              : undefined
          }
          intl={intl}
          title={
            'Preheader' in wrongDynamicTagsGroup
              ? ''
              : intl.formatMessage({
                  id: 'Load.EmailCheckUp.SecntionDynamicFields'
                })
          }
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.DynamicFieldsHeaderTitleIntl'
            },
            {
              link: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={1}
                  onClick={e => handleClick(e, SECTION.subject)}
                >
                  {e}
                </Link>
              )
            }
          )}
          setModalState={setMdState}
          addToWhiteList={addToWhiteList}
          checkSummary
          icon={!dynamicFieldsOptionEnabled ? 'alert' : undefined}
          callbackSaveItems={() => callbackSaveItems()}
        />
      </>
    )

  const dynamicFieldBody = wrongDynamicTagsGroup &&
    'Body' in wrongDynamicTagsGroup && (
      <>
        <DynamicFieldItem
          section={SECTION.body}
          items={wrongDynamicTagsGroup.Body}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.DynamicFieldsWarning,
              e.toLowerCase()
            )
          }
          alert={
            !dynamicFieldsOptionEnabled
              ? silencedAlertsArray.length > 0 &&
                silencedAlertsArray.find(
                  e =>
                    e.issueType ===
                    EmailMessageCheckUpIssueType.DynamicFieldsWarning
                ).silenced
              : undefined
          }
          intl={intl}
          title={
            'Subject' in wrongDynamicTagsGroup ||
            'Preheader' in wrongDynamicTagsGroup
              ? ''
              : intl.formatMessage({
                  id: 'Load.EmailCheckUp.SecntionDynamicFields'
                })
          }
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.DynamicFieldsBodyTitleIntl'
            },
            {
              link: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={1}
                  onClick={e => handleClick(e, SECTION.body)}
                >
                  {e}
                </Link>
              )
            }
          )}
          setModalState={setMdState}
          addToWhiteList={addToWhiteList}
          checkSummary
          icon={!dynamicFieldsOptionEnabled ? 'alert' : undefined}
          callbackSaveItems={() => callbackSaveItems()}
        />
      </>
    )

  const handleClose = () => {
    setMdState(prev => ({
      ...prev,
      show: false
    }))
  }

  const propsOptionEnabled = () => ({
    itemKey: 'item-opt-enabled',
    icon: ICON_ALERT,
    callbackAlert: e =>
      changeAlert(
        EmailMessageCheckUpIssueType.DynamicFieldsWarning,
        e.toLowerCase()
      ),
    alert:
      silencedAlertsArray.length > 0 &&
      silencedAlertsArray.find(
        e => e.issueType === EmailMessageCheckUpIssueType.DynamicFieldsWarning
      ).silenced,
    title: intl.formatMessage({
      id: 'Load.EmailCheckUp.DynamicFieldsOptDisabled'
    }),
    description: intl.formatMessage(
      {
        id: 'Load.EmailCheckUp.SummaryDynamicTagsAlert1Intl'
      },
      {
        link: e => (
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            key='tag-alert-link'
            onClick={handleClose}
          >
            {e}
          </Link>
        ),
        br: <br key='tag-alert-br' />,
        strong: tokens => <strong key='tag-alert-strong'>{tokens}</strong>
      }
    )
  })

  return (
    <>
      {dynamicFieldsOptionEnabled && (
        <CheckItem
          {...propsOptionEnabled()}
          data-mu-test='potential-details__dynamic-fields-warning--ko'
        />
      )}

      {wrongDynamicTags && wrongDynamicTags.length > 0 && (
        <>
          {dynamicFieldPreheader}
          {dynamicFieldSubject}
          {dynamicFieldBody}
        </>
      )}
    </>
  )
}

export default SummaryDynamicFieldCheck

SummaryDynamicFieldCheck.propTypes = {
  idMessage: PropTypes.number,
  isBee: PropTypes.bool
}
